<mat-table [dataSource]="table.dataTable" class="tracker-table">
  <ng-container matColumnDef="patientName">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell [ngClass]="{'red-bg': !didPatientAttend(group.appointments)}" *matCellDef="let group">
      {{group.patient.firstName}} {{group.patient.lastName}}
      <mat-progress-spinner style="display: inline-block; float: right;" diameter="25" mode="indeterminate"
      [style.display]="table.isWorking[group.track.newPatientTrackId] ? '': 'none'"></mat-progress-spinner>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="responsibleName">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let group">{{getResponsibleName(group.responsibleParties)}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let group">
      <button mat-mini-fab class="patient-button" matTooltip="View Financials" matTooltipPosition="above"
        (click)="showPatientDetailsModal(group.patient.patientId, PatientDetailsArea.Financial)">
        <mat-icon>attach_money</mat-icon>
      </button>
      &nbsp;
      <button mat-mini-fab class="patient-button" matTooltip="View Communication" matTooltipPosition="above"
        (click)="showPatientDetailsModal(group.patient.patientId, PatientDetailsArea.Communication, CommunicationType.Default)">
        <mat-icon>forum</mat-icon>
      </button>
      &nbsp;
      <button mat-mini-fab class="patient-button" matTooltip="Contact Info" matTooltipPosition="above"
        #PatientContactBtn (click)="openPatientContactInfo(PatientContact, PatientContactBtn)">
        <mat-icon>call</mat-icon>
      </button>
      <ng-template #PatientContact>
        <span class="all-time-wins">
          <mat-list dense class="patient-contact-info">
            @switch (group.responsibleParties.length > 0) {
              @case (true) {
                @for (rp of group.responsibleParties; track rp) {
                  <mat-list-item>
                    <span class="label" matLine>{{rp.firstName}} {{rp.lastName}}</span>
                    <span matLine>{{rp.cellPhone | phoneNumber}}</span>
                  </mat-list-item>
                }
              }
              @case (false) {
                <mat-list-item>
                  <span class="label" matLine>{{group.patient.firstName}} {{group.patient.lastName}}</span>
                  <span matLine>{{group.patient.cellPhone | phoneNumber}}</span>
                </mat-list-item>
              }
            }
          </mat-list>
        </span>
      </ng-template>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="treatmentStatus">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let group">{{getTreatmentStatus(group.patient.treatmentStatusId)}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="appointment">
    <mat-header-cell *matHeaderCellDef>Appointment</mat-header-cell>
    <mat-cell [ngClass]="{'red-font': !didPatientAttend(group.appointments)}" *matCellDef="let group">
      <div>{{getTrackAppointmentDisplay(group)}}</div>
      @if (!didPatientAttend(group.appointments)) {
        <div>
          @if (group.patient.followUpLinkId === null) {
            <img src="./assets/images/warning_icon_red.svg" height="20" class="appt-img" [matMenuTriggerFor]="menu"
              />
          }
          @if (group.patient.followUpLinkId !== null) {
            <img src="./assets/images/hi.png" height="20" class="appt-img" />
          }
          <mat-menu #menu="matMenu" class="appt-menu">
            <button mat-menu-item class="appt-menu-item"
            (click)="showAvaFollowUpModal(AvaFollowUpOptions.Auto, group)">Auto</button>
            <button mat-menu-item class="appt-menu-item"
            (click)="showAvaFollowUpModal(AvaFollowUpOptions.Set, group)">Set</button>
            <button mat-menu-item class="appt-menu-item"
            (click)="showAvaFollowUpModal(AvaFollowUpOptions.Remind, group)">Remind</button>
            <button mat-menu-item class="appt-menu-item red-font" (click)="removePatient(group)">Remove</button>
          </mat-menu>
        </div>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="reactionActions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let group"></mat-cell>
  </ng-container>
  <ng-container matColumnDef="welcome">
    <mat-header-cell *matHeaderCellDef class="column-header">Welcome</mat-header-cell>
    <mat-cell *matCellDef="let group" class="column-cell">
      @if (group.track.welcomeSequenceStarted) {
        <mat-icon>check</mat-icon>
      }
      @if (!group.track.welcomeSequenceStarted) {
        <button mat-raised-button class="blue-button" color="primary"
          (click)="addPatientsToWelcomeSequence([group.track.newPatientTrackId])"
        >Start</button>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="forms">
    <mat-header-cell *matHeaderCellDef class="column-header">Forms</mat-header-cell>
    <mat-cell *matCellDef="let group" class="column-cell forms-cell">
      @if (!group.track.formsComplete) {
        <button mat-raised-button class="blue-button" color="primary" (click)="openFormsDialog(group)"
        >Fill</button>
      }
      @if (group.track.formsComplete) {
        <a href="javascript:void(0);" (click)="openFormsPdf(group)">
          <mat-icon>check</mat-icon>
          <img src="./assets/images/details_icon.svg" height="13" class="details-image" />
        </a>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="insurance">
    <mat-header-cell *matHeaderCellDef class="column-header">Insurance</mat-header-cell>
    <mat-cell *matCellDef="let group" class="column-cell">
      @switch (group.track.insuranceVerified) {
        @case (true) {
          <mat-icon>check</mat-icon>
        }
        @case (false) {
          <button mat-raised-button class="blue-button"
          (click)="setInsuranceVerification(group, true)">Verify</button>
        }
        @case (null) {
          <mat-icon class="insurance-dot-icon">fiber_manual_record</mat-icon>
        }
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="survey">
    <mat-header-cell *matHeaderCellDef class="column-header">Survey</mat-header-cell>
    <mat-cell *matCellDef="let group" class="column-cell">
      @if (group.track.surveyComplete) {
        <mat-icon>check</mat-icon>
      }
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
</mat-table>

<ng-template #confirmWelcomeSequenceTemplate let-dialogRef="dialogRef">
  <h3>Do you want to start the Welcome Sequence?</h3>
  <div mat-dialog-actions>
    <button mat-button color="primary" (click)="dialogRef.close(true)" cdkFocusInitial>Yes</button>
    <button mat-button color="warn" (click)="dialogRef.close(false)">Cancel</button>
  </div>
</ng-template>

<ng-template #confirmInsuranceTemplate let-dialogRef="dialogRef">
  <h3>Are you sure you wish to confirm this patient's insurance?</h3>
  <div mat-dialog-actions>
    <button mat-button color="primary" (click)="dialogRef.close(true)" cdkFocusInitial>Yes</button>
    <button mat-button color="warn" (click)="dialogRef.close(false)">Cancel</button>
  </div>
</ng-template>

<ng-template #openFormsDialogTemplate let-dialogRef="dialogRef">
  <h3 mat-dialog-title>Patient Forms</h3>
  <div mat-dialog-content>
    <mat-action-list>
      <button mat-list-item class="forms-action-button"
      (click)="dialogRef.close({ location: 'local', target: null })">Fill out forms here</button>
      <button mat-list-item class="forms-action-button" (click)="showTargets = !showTargets">Open on another
      device</button>
    </mat-action-list>
    @if (showTargets) {
      <div>
        <mat-form-field>
          <mat-label>Target Machine</mat-label>
          <mat-select #Target="matSelect">
            @for (target of remoteTargets; track target) {
              <mat-option [value]="target">
                {{target}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button mat-button (click)="dialogRef.close({ location: 'remote', target: Target.value })"
        cdkFocusInitial>Go</button>
      </div>
    }
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="dialogRef.close(false)">Cancel</button>
  </div>
</ng-template>
